import { USER_API } from "../../constants/ENDPOINTS/EndPoints";
import { HTTP } from "../../constants/HTTP/Http";
import { backendApi } from "../../redux/base.config";

export const Scripts = backendApi.injectEndpoints({

    endpoints: (builder) => ({
        fetchAllScriptProgram: builder.mutation({
            query: (data) => ({
                url: USER_API.SCRIPTS,
                method: HTTP.GET,
                params: data
            })
        }),
        fetchAllMLScript: builder.mutation({
            query: (data) => ({
                url: USER_API.GET_ALL_ML_SCRIPTS,
                method: HTTP.GET,
                params: data
            })
        }),

        createScripts: builder.mutation({
            query: (data) => ({
                url: USER_API.CREATE_SCRIPTS,
                method: HTTP.POST,
                body: data?.body,
                params: data?.params
            })
        }),

        revertScript: builder.mutation({
            query: (data) => ({
                url: USER_API.REVERT_SCRIPTS,
                method: HTTP.PUT,
                body: data
            })
        }),

        getStageMasterName: builder.mutation({
            query: (data) => ({
                url: USER_API.STAGE_DROPDOWN,
                method: HTTP.GET,
                body: data
            })
        }),

        getDnaAnalysisName: builder.mutation({
            query: (data) => ({
                url: USER_API.ANALYSIS_DROPDOWN,
                method: HTTP.GET,
                body: data
            })
        }),

        fetchAllScriptByAnalysisId: builder.mutation({
            query: (data) => ({
                url: USER_API.SCRIPT_ANALYSIS,
                method: HTTP.GET,
                params: data
            })
        }),

        fetchAllScriptPath: builder.mutation({
            query: (data) => ({
                url: USER_API.SCRIPTS_ROOT_PATH_NAME,
                method: HTTP.GET,
                params: data
            })
        }),




    })
})

export const {
    useFetchAllScriptProgramMutation,
    useCreateScriptsMutation,
    useRevertScriptMutation,
    useGetStageMasterNameMutation,
    useGetDnaAnalysisNameMutation,
    useFetchAllScriptByAnalysisIdMutation,
    useFetchAllScriptPathMutation,
    useFetchAllMLScriptMutation
} = Scripts